import * as Api from '@ViewModels';
import { css, StyleDeclaration } from 'aphrodite';
import { styleSheet } from './styles';

const handwritingStyleFontMap: Partial<
	Record<Api.HandwritingStyle, { fontFamily: string; fontSize: number; lineHeight: number }>
> = {
	[Api.HandwritingStyle.Aladdin]: {
		fontFamily: Api.HandwritingStyle.Aladdin,
		fontSize: 22,
		lineHeight: 1,
	},
	[Api.HandwritingStyle.Cinderella]: {
		fontFamily: Api.HandwritingStyle.Cinderella,
		fontSize: 22,
		lineHeight: 1,
	},
	[Api.HandwritingStyle.Donald]: {
		fontFamily: Api.HandwritingStyle.Donald,
		fontSize: 22,
		lineHeight: 1,
	},
	[Api.HandwritingStyle.Nemo]: {
		fontFamily: Api.HandwritingStyle.Nemo,
		fontSize: 22,
		lineHeight: 1,
	},
	[Api.HandwritingStyle.Scar]: {
		fontFamily: Api.HandwritingStyle.Scar,
		fontSize: 22,
		lineHeight: 1,
	},
	[Api.HandwritingStyle.Tarzan]: {
		fontFamily: Api.HandwritingStyle.Tarzan,
		fontSize: 30,
		lineHeight: 0.75,
	},
	[Api.HandwritingStyle.Woody]: {
		fontFamily: Api.HandwritingStyle.Woody,
		fontSize: 22,
		lineHeight: 1,
	},
};

// Template layout constants based on actual card dimensions
const CARD_LAYOUT = {
	landscapeHalf: {
		// Signature should be positioned from bottom for landscape-half cards
		signatureFromTop: '50%',
	},
	landscapeFull: {
		// Signature should be positioned from bottom for landscape-full cards
		signatureFromTop: '70%',
	},
};

// Mirrors CardlyClient.ApplyLandscapeTemplate in Levitate-API, which picks the Cardly template the card is printed
// on: body lines are estimated at a fixed 55 characters regardless of font, and more than 6 selects landscape-full.
const PLATFORM_MAX_LINE_LENGTH = 55;
const PLATFORM_LANDSCAPE_HALF_MAX_LINES = 6;

function estimatePlatformBodyLines(postcardText: string) {
	return postcardText
		.replace(/\r\n/g, '\n')
		.replace(/[\r\n]+$/, '')
		.split('\n')
		.reduce((totalLines, line) => totalLines + Math.max(1, Math.ceil(line.length / PLATFORM_MAX_LINE_LENGTH)), 0);
}

function calculateSignaturePosition(postcardText: string): {
	position: 'absolute';
	top: string;
	left: string;
} {
	const layout =
		estimatePlatformBodyLines(postcardText) <= PLATFORM_LANDSCAPE_HALF_MAX_LINES
			? CARD_LAYOUT.landscapeHalf
			: CARD_LAYOUT.landscapeFull;

	return {
		position: 'absolute',
		top: layout.signatureFromTop,
		left: '40%',
	};
}

export function HwcTextPreview({
	handwritingStyle,
	postcardText,
	signature,
	styleDeclaration,
}: {
	handwritingStyle: Api.HandwritingStyle;
	postcardText: string;
	signature: string;
	styleDeclaration?: StyleDeclaration;
}) {
	const fontSettings =
		handwritingStyleFontMap[handwritingStyle] || handwritingStyleFontMap[Api.HandwritingStyle.Aladdin];
	const signaturePosition = calculateSignaturePosition(postcardText);
	const hasSignature = signature.trim().length > 0;

	return (
		<div
			className={css(styleSheet.mainPreview, styleSheet.mainPreviewModeText, styleDeclaration)}
			style={{
				fontFamily: fontSettings.fontFamily,
				fontSize: fontSettings.fontSize,
				lineHeight: fontSettings.lineHeight,
				position: 'relative',
			}}
		>
			<p className={css(styleSheet.mainPreviewTextContent)}>{postcardText}</p>
			{hasSignature ? (
				<p className={css(styleSheet.mainPreviewSignature)} style={signaturePosition}>
					{signature}
				</p>
			) : null}
		</div>
	);
}
